import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlogService } from 'app/blog/blog.service';
import { BlogContent } from 'app/blog/types/blog-content.model';
import { Tags } from 'app/blog/types/tags.model';
import { environment } from 'environments/environment';
import { MetafrenzyService } from 'ngx-metafrenzy';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-content-item',
  templateUrl: './content-item.component.html',
  styleUrls: ['./content-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContentItemComponent implements OnInit, OnDestroy {
  content: BlogContent;
  source: string;
  url = '';
  latestContent: BlogContent[] = [];
  tags: Tags[] = [];

  private unsubscribeAll: Subject<any>;

  constructor(
    private route: ActivatedRoute,
    private readonly metafrenzyService: MetafrenzyService,
    private blogService: BlogService
  ) {
    this.unsubscribeAll = new Subject();
    this.route.paramMap.subscribe(() => {
      this.content = this.route.snapshot.data.data.blogContent as BlogContent;
      this.blogTitle = this.content.contentTitle;
      this.blogSubtitle = this.content.contentDescription;
    });
  }

  set blogTitle(value: string) {
    this.blogService.blogTitle = value;
  }
  set blogSubtitle(value: string) {
    this.blogService.blogSubtitle = value;
  }

  ngOnInit(): void {
    this.url = `${environment.landingUrl}/${this.route.snapshot.url.join('/')}`;

    const title = 'Blog | Wipperoz -';

    this.metafrenzyService.setTitle(`${title} ${this.content.contentTitle}`);
    this.metafrenzyService.setMetaTag('description', this.content.contentDescription);
    this.metafrenzyService.setMetaTag('og:title', this.content.contentTitle);
    this.metafrenzyService.setMetaTag('og:description', this.content.contentDescription);
    this.metafrenzyService.setMetaTag('twitter:title', this.content.contentTitle);
    this.metafrenzyService.setMetaTag('twitter:description', this.content.contentDescription);
    this.metafrenzyService.setMetaTag('image', this.content.featureImageUrl);
    this.metafrenzyService.setMetaTag('twitter:image', this.content.featureImageUrl);
    this.metafrenzyService.setMetaTag('og:image', this.content.ogImageUrl);
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
